// extracted by mini-css-extract-plugin
module.exports = {"ourProcessTitle":"OurProcessTitle_ourProcessTitle__2PtsK","ourProcessTitleHeading":"OurProcessTitle_ourProcessTitleHeading__2Zdbq"};